import type { IEnrichedIndustry } from "app/pages/industry-analysis/home/enriched-custom-industries/types";
import type { FC } from "react";
import { colorsPalettes, rgba } from "@similarweb/styles";
import styled from "styled-components";
import { Header } from "app/pages/industry-analysis/home/enriched-custom-industries/Header";
import { TrafficAndEngagementData } from "app/pages/industry-analysis/home/enriched-custom-industries/TrafficAndEngagementData/TrafficAndEngagementData";
import type { IActionItemsBase } from "app/pages/industry-analysis/home/enriched-custom-industries/ActionItems";
import { ActionItems } from "app/pages/industry-analysis/home/enriched-custom-industries/ActionItems";
import { FadeWrapper } from "app/pages/industry-analysis/home/StyledComponents";
import { CategoryServiceUtils } from "app/services/CategoryServiceUtils";

const { carbon } = colorsPalettes;

interface IIndustryItem {
    industry: IEnrichedIndustry;
    isLoading: boolean;
    onClick: VoidFunction;
    actionItemsProps?: IActionItemsBase;
}

const Container = styled.div<{ showTrafficAndEngagementData }>`
    padding: 16px 20px;
    display: ${({ showTrafficAndEngagementData }) => (showTrafficAndEngagementData ? "grid" : "flex")};
    grid-template-columns: 52% 35% 13%;
    background-color: white;
    border-radius: 4px;
    box-shadow: 0px 3px 6px ${rgba(carbon[500], 0.08)};
    border: 1px solid ${carbon[0]};
    cursor: pointer;
    &:hover {
        border-color: ${carbon[100]};
        transition: border-color 200ms ease;
    }
    &:hover ${FadeWrapper} {
        opacity: 1;
    }
`;

export const IndustryItem: FC<IIndustryItem> = (props) => {
    const { isLoading, industry, onClick, actionItemsProps } = props;
    const showTrafficAndEngagementData = !CategoryServiceUtils.hasSegments(industry);
    return (
        <Container
            onClick={onClick}
            showTrafficAndEngagementData={showTrafficAndEngagementData}
        >
            <Header industry={industry} />
            {showTrafficAndEngagementData && (
                <TrafficAndEngagementData
                    industry={industry}
                    isLoading={isLoading}
                />
            )}
            <ActionItems
                industry={industry}
                {...actionItemsProps}
            />
        </Container>
    );
};
